import { Dialog, DialogActions, DialogContent, DialogTitle, Tab, Tabs } from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useLocation } from 'react-router-dom';
import { FaFilePdf } from "react-icons/fa6";
import BlurLoader from '../CommonComponents/BlurFullPageLoader';
import { NotificationSound } from '../CommonComponents/CommonNotification';
import { ApiCall, getDateAndTime } from '../CommonComponents/CustomHooks';
import FinalView from '../CommonComponents/FinalView';
import ThankYou from '../CommonComponents/ThankYou';
import { TrackStepper } from '../SaleEntry/Stepper';
import { base64ToBlob } from '../CommonComponents/EnvConfig';
import { GetSession, SetSession } from '../CommonComponents/cryptoUtils';

const CustomerPayment = () => {
    const inputrefs = useRef([])
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const HeaderID = queryParams.get('HeaderID');
    const HeaderIDLocal = GetSession('localstorage', 'HeaderID')
    const CToken = queryParams.get('Token');
    const [Progress, setProgress] = useState('50%');
    const [PaymentResponse, setPaymentResponse] = useState({});
    const [message, setMessage] = useState('');
    const [conformationType, setConfirmationType] = useState('')
    const [SubLoading, setSubLoading] = useState(false);
    const [isChecked, setIsChecked] = useState(false);
    const [openPaymentModal, setOpenPaymentModal] = useState(false);
    const [QueryCancelStatus, setQueryCancelStatus] = useState(false);
    const [ProcessType, setProcessType] = useState(true);
    const [PaymentProcessType, setPaymentProcessType] = useState('CONFIRM');
    const PageName = 'CustomerPayment'
    const [ShowSelectionForm, setShowSelectionForm] = useState({
        invoiceForm: true,
        productForm: true,
        customerForm: true,
        amountForm: true
    });

    const [formData, setFormData] = useState({
        type: '',
        productCode: '',
        headerID: '',
        ModelId: '',
        businessPartner: '',
        sumInsured: '',
        title: '',
        firstName: '',
        lastName: '',
        gender: '',
        category: '',
        manufacturer: '',
        otherManufacturer: '',
        serialNo: '',
        invoiceNo: '',
        totalInvoiceValue: '',
        invoiceDate: getDateAndTime().date,
        noOfYears: '',
        cost: '',
        currency: '',
        dealerName: '',
        bankReference: '',
        salesChannelDetail: '',
        salesChannelSecondDetail: '',
        dealerCode: '',
        delaerLocation: '',
        modelNo: '',
        otherModelNo: '',
        imei: '',
        purchaseDate: getDateAndTime().date,
        billingAddressLine1: '',
        billingAddressLine2: '',
        billingAddressLine3: '',
        billingTown: '',
        billingPostcode: '',
        billingState: '',
        telephoneNumber: '',
        emailAddress: '',
        mobilePhoneNumber: '',
        selectionType: '',
        paymentType: '',
        commsDirectMail: '',
        commsEmail: '',
        commsFax: '',
        commsSms: '',
        commsTelemarket: '',
        paymentStatus: '',
        applicationStatus: '',
        remarks: '',
        isRemember: false,
        "manufacturerModelNo": "",
        "manufacturerWarrantyPeriodYears": "",
        assestProductName: '',
        activationDate: '',
        employeeID: '',
        invoiceExt: '',
        invoiceImage: '',
        imeiImage: '',
        imeiExt: '',
        pdfurl: '',
    });

    const [customerData, setCustomerData] = useState({
        message: '',
    });

    const getSalesDetails = async (value) => {
        const requestData = {
            HeaderID: value, loginToken: CToken, PageName: PageName, UserCode: ''
        };
        let res = await ApiCall(`/api/DealerMaster/GetSaleEntryDetail`, requestData)
        if (res.status === "SUCCESS") {
            setFormData((pre) => ({
                ...pre, ...res
            }))
        } else if (res.status === "EXPIRED") {
            setQueryCancelStatus(true); setConfirmationType(res.status)
            setFormData({ ...formData, headerID: '' })
        } else {
            await NotificationSound(res.status, res.message, res.focus, inputrefs)
        }
    }

    const handleClear = () => {
        setFormData({
            type: formData.type,
            productCode: '',
            headerID: '',
            businessPartner: '',
            sumInsured: '',
            title: '',
            firstName: '',
            lastName: '',
            gender: '',
            category: '',
            manufacturer: '',
            otherManufacturer: '',
            serialNo: '',
            invoiceNo: '',
            totalInvoiceValue: '',
            invoiceDate: getDateAndTime().date,
            noOfYears: '',
            cost: '',
            currency: '',
            dealerName: '',
            bankReference: '',
            salesChannelDetail: '',
            salesChannelSecondDetail: '',
            dealerCode: '',
            delaerLocation: '',
            modelNo: '',
            otherModelNo: '',
            imei: '',
            purchaseDate: getDateAndTime().date,
            billingAddressLine1: '',
            billingAddressLine2: '',
            billingAddressLine3: '',
            billingTown: '',
            billingPostcode: '',
            billingState: '',
            telephoneNumber: '',
            emailAddress: '',
            mobilePhoneNumber: '',
            selectionType: '',
            paymentType: '',
            commsDirectMail: '',
            commsEmail: '',
            commsFax: '',
            commsSms: '',
            commsTelemarket: '',
            paymentStatus: '',
            applicationStatus: '',
            remarks: '',
            manufacturerModelNo: "",
            manufacturerWarrantyPeriodYears: "",
            assestProductName: ''
        });
        setPaymentProcessType('CONFIRM');
        setProgress('50%');
        setCustomerData({ ...customerData, message: '' })
    }

    const tabData = [
        {
            tabName: 'Phone',
            tabKey: 'PHONESAFE'
        },
        {
            tabName: 'Asset',
            tabKey: 'ASSET'
        }
    ];

    const handleTabChange = (event, newValue) => {
        setFormData({
            ...formData, type: newValue,
            "manufacturerModelNo": "",
            "manufacturerWarrantyPeriodYears": ""
        })
    };

    const HandleProcess = (type) => {
        setOpenPaymentModal(true)
        if (type === 'QUERY') {
            setProcessType(true)
        } else {
            setProcessType(false)
        }
    }

    const handleProcessSubmit = async () => {
        const requestData = {
            HeaderID: HeaderID,
            loginToken: CToken,
            UserCode: 'Customer',
            message: customerData.message,
            processType: ProcessType ? 'Query' : 'Cancel'
        };
        let res = await ApiCall(`/api/DealerMaster/CancelQuerryStatus`, requestData)
        await setOpenPaymentModal(false)
        if (res.status === 'SUCCESS') {
            await setCustomerData({ ...customerData, message: '' })
            await setMessage(res.message)
            await setQueryCancelStatus(true)
            if (!ProcessType) {
                setConfirmationType('CANCEL')
            }
        } else if (res.status === "EXPIRED") {
            setQueryCancelStatus(true); setConfirmationType(res.status)
            setFormData({ ...formData, headerID: '' })
        } else {
            await NotificationSound(res.status, res.message, res.focus, inputrefs)
        }
    }

    const handlePayment = async (e) => {
        e.preventDefault();
        if (!isChecked) {
            await NotificationSound('ERROR', 'Please check our term & conditions !')
            return
        }
        const requestData = {
            "HeaderID": HeaderID,
            "loginToken": CToken,
            UserCode: 'Customer'
        };

        try {
            await (setSubLoading(true))
            await SetSession('localstorage', 'HeaderID', HeaderID)
            const data = await ApiCall('/api/SalesEntryAPI/MakePayment', requestData)
            if (data.status === "SUCCESS") {
                if (data.payByToken) {
                    await initiateCheckout(data.token);
                    await window.localStorage.setItem('OnlinePaymentID', '');
                } else {
                    await window.localStorage.setItem('OnlinePaymentID', data.orderId);
                    window.location.href = data.paymentURL;
                    await (setSubLoading(false))
                }
            } else if (data.status === "EXPIRED") {
                setQueryCancelStatus(true); setConfirmationType(data.status)
                setFormData({ ...formData, headerID: '' })
            } else {
                await (setSubLoading(false))
                await NotificationSound(data.status, data.message);
            }
        } catch (error) {
            await (setSubLoading(false))
            console.error('Error in payment process:', error);
        }
    };

    const initiateCheckout = async (token) => {
        await (setSubLoading(false))
        const initData = {
            token: token,
            waProfileData: '',
            key: JSON.stringify({
                curCredentials: {
                    pkcsSalt: '',
                    rsaSalt: '',
                },
            }),
        };
        if (window.bfl && window.bfl.initiate) {
            window.bfl.initiate(initData);
        } else {
            console.error('Bajaj Finserv Checkout JS is not available');
        }
    };

    const handleCheckResponse = async (value) => {
        const requestData = {
            "OnlinePaymentID": value,
            headerID: HeaderIDLocal,
        };
        try {
            await (setSubLoading(true))
            const data = await ApiCall('/api/SalesEntryAPI/CheckPaymentStatus', requestData)
            if (data.status === 'SUCCESS') {
                if (data.policyStatus === 'SUCCESS') {
                    setPaymentProcessType('FINAL')
                    setMessage(data.message)
                    setProgress('100%')
                }
                else if (data?.paymentDataResponse?.statusCode === '00') {
                    await (setSubLoading(false))
                    await setPaymentResponse({ errorDesc: 'Payment completed successfully!', status: 'SUCCESS' })
                    await setPaymentProcessType('PAYMENT')
                    await setProgress('80%')
                }
                else {
                    await (setSubLoading(false))
                    await setPaymentResponse({ errorDesc: 'Something went wrong please try after sometime.!', status: 'Failed' })
                    await setPaymentProcessType('PAYMENT')
                    await setProgress('80%')
                }
            }
            else {
                await (setSubLoading(false))
                await NotificationSound(data.status, data.message);
            }

        } catch (error) {
            await (setSubLoading(false))
            console.error('Error in payment process:', error);
        }
    };

    //const handleSubmitRef = async (orderId) => {
    //    await (setSubLoading(true))
    //    let data = await ApiCall(`/api/SalesEntryAPI/GeneratePolicyNo`, {
    //        HeaderID: HeaderID ? HeaderID : HeaderIDLocal,
    //        loginToken: CToken,
    //        UserCode: 'Customer',
    //        PageName: PageName,
    //        OnlinePaymentID: orderId
    //    })
    //    await (setSubLoading(false))
    //    if (data.status === 'SUCCESS') {
    //        setPaymentProcessType('FINAL')
    //        setMessage(data.message)
    //        setProgress('100%')
    //    }
    //    else if (data.status === "EXPIRED") {
    //        setQueryCancelStatus(true); setConfirmationType(data.status)
    //        setFormData({ ...formData, headerID: '' })
    //    } else {
    //        await NotificationSound(data.status, data.message, data.focus, inputrefs)
    //    }
    //};

    useEffect(() => {
        const handlePaymentUpdate = async (event) => {
            const paymentResponse = event?.detail?.response;
            if (paymentResponse.code === '00') {
                await handleCheckResponse(event?.detail?.redirectParam?.param[2]?.orderId, formData.headerId)
            } else if (paymentResponse.code === '11') {
                await (setSubLoading(false))
                await setPaymentResponse(paymentResponse)
                await setPaymentProcessType('PAYMENT')
                await setProgress('80%')
            }
        };
        /******** for Resolving ERROR ***********/
        let payButton = document.createElement("div");
        payButton.id = "paybutton";
        payButton.innerHTML = ".";
        payButton.addEventListener("click", function () {
            console.log("Payment initiated !");
        });
        document.body.appendChild(payButton)
        let newElement = document.createElement("div");
        newElement.id = "checkoutRefFailed";
        newElement.innerHTML = ".";
        document.body.appendChild(newElement);
        window.addEventListener('checkoutUpdate', handlePaymentUpdate);
        let a = document.getElementById("checkoutRefFailed")
        /******** for Resolving ERROR ***********/

        /******** for Resolving SUCCESS of payment getway end ***********/
        document.body.appendChild(payButton)
        let newElement1 = document.createElement("div");
        newElement1.id = "checkoutRefSuccess";
        newElement1.innerHTML = ".";
        document.body.appendChild(newElement1);
        window.addEventListener('checkoutUpdate', handlePaymentUpdate);
        let a1 = document.getElementById("checkoutRefFailed")
        /******** for Resolving SUCCESS of payment getway end ***********/

        return () => {
            window.removeEventListener('checkoutUpdate', handlePaymentUpdate);
        };
    }, []);

    const handleRetryPayment = async () => {
        await setPaymentProcessType('CONFIRM')
        await setProgress('50%')
    };

    const OpenImage = (fileBase64, ext) => {
        if (ext === 'pdf') {
            const blob = base64ToBlob(fileBase64, 'application/pdf');
            const url = URL.createObjectURL(blob);
            const pdfWindow = window.open(url, '_blank');
            if (!pdfWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            pdfWindow.document.title = "View PDF";
        } else {
            const blob = base64ToBlob(fileBase64, 'image/jpeg');
            const url = URL.createObjectURL(blob);
            const imageWindow = window.open(url, '_blank');
            if (!imageWindow) {
                throw new Error("Please allow pop-ups for this site");
            }
            imageWindow.document.title = "View Image";
        }
    }

    useEffect(() => {
        if (HeaderID) {
            getSalesDetails(HeaderID)
        }
    }, [HeaderID])

    useEffect(() => {
        document.title = 'Customer Payment'
        document.body.classList.add('light');
    }, [])

    return (
        <>

            <main id='main' className='main mt-0' style={{ fontSize: '10px' }}>
                <div className='main-card card'>
                    {formData.headerID === '' ? <></> :
                        !QueryCancelStatus &&
                        <div className=' row px-3 '>
                            <div className='card-header pb-1' style={{ padding: "5px" }}>
                                <div className='col-md-12 px-1'>
                                    <div className='row'>
                                        <h6 className="m-0">  {'Make Payment'} </h6>
                                        <div className='p-1' >
                                            <TrackStepper Progress={Progress} formData={formData} type={'Customer'} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {(PaymentProcessType === 'CONFIRM' && !QueryCancelStatus) ?
                        formData.headerID === '' ? <></> :
                            <>
                                <div className='main_cn_tab'>
                                    <Tabs
                                        sx={{ minHeight: '20px' }}
                                        value={formData.type}
                                        onChange={handleTabChange}
                                        variant="scrollable"
                                        scrollButtons={false}
                                        aria-label="scrollable prevent tabs example"
                                    >
                                        {tabData?.filter(item => (formData?.type === 'PHONESAFE' && item.tabKey === 'PHONESAFE') || (formData?.type === 'ASSET' && item.tabKey === 'ASSET')).map((item, index) =>
                                            <Tab
                                                key={`tabs${index}`}
                                                label={item.tabName}
                                                value={item.tabKey}
                                            />
                                        )}
                                    </Tabs>
                                </div>
                                <div className='card-header'>
                                    <div className='container-fluid px-0'>
                                        <div className='row'>
                                            <div className='col-md-9 pe-md-1'>

                                                <div className='card mb-2' style={{ borderTop: '2px solid #865fc5', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px' }}>
                                                    <div className='card-body p-2 py-0'>
                                                        <div className="invoice-header d-flex justify-content-between align-items-center py-2 px-1">
                                                            <h6 className="invoice-title my-0" style={{ borderBottom: '2px solid #865fc5', color: '#865fc5' }}>
                                                                Invoice Details
                                                            </h6>
                                                            <span className="toggle-icon-container">
                                                                {ShowSelectionForm.invoiceForm ?
                                                                    <IoIosArrowUp className="toggle-icon toggle-icon-up" onClick={() => setShowSelectionForm((pre) => ({ ...pre, invoiceForm: false }))} /> :
                                                                    <IoIosArrowDown className="toggle-icon toggle-icon-down" onClick={() => setShowSelectionForm((pre) => ({ ...pre, invoiceForm: true }))} />}
                                                            </span>
                                                        </div>


                                                        {ShowSelectionForm.invoiceForm &&
                                                            <div className='customer_table'>
                                                                <table className='table table-bordered'>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th>Invoice No</th>
                                                                            <td className='fw-bold text-primary'>{formData.invoiceNo}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Invoice Date</th>
                                                                            <td>{formData.invoiceDate}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Activation Date</th>
                                                                            <td>{formData.activationDate}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Invoice Value</th>
                                                                            <td>₹ {formData.totalInvoiceValue} {formData.invoiceExt === 'pdf' ?
                                                                                <FaFilePdf title='open PDF'
                                                                                    style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '16px' }}
                                                                                    onClick={() => { OpenImage(formData.invoiceImage, formData.invoiceExt) }}
                                                                                /> :
                                                                                <i className="fa fa-image me-2"
                                                                                    title='show Image'
                                                                                    onClick={() => { OpenImage(formData.invoiceImage, formData.invoiceExt) }}
                                                                                    style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}
                                                                                />
                                                                            }</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Employee ID</th>
                                                                            <td>{formData.employeeID}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Sum Insured</th>
                                                                            <td>₹ {formData.sumInsured}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className='card mb-2' style={{ borderTop: '2px solid #ff0000', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px' }}>
                                                    <div className='card-body p-2 py-0'>
                                                        <div className="invoice-header d-flex justify-content-between align-items-center py-2 px-1">
                                                            <h6 className="invoice-title my-0" style={{ borderBottom: '2px solid #ff0000', color: '#ff0000' }}>
                                                                Product Details
                                                            </h6>
                                                            <span className="toggle-icon-container">
                                                                {ShowSelectionForm.productForm ?
                                                                    <IoIosArrowUp className="toggle-icon toggle-icon-up" onClick={() => setShowSelectionForm((pre) => ({ ...pre, productForm: false }))} /> :
                                                                    <IoIosArrowDown className="toggle-icon toggle-icon-down" onClick={() => setShowSelectionForm((pre) => ({ ...pre, productForm: true }))} />}
                                                            </span>
                                                        </div>
                                                        {ShowSelectionForm.productForm &&
                                                            <div className='customer_table'>
                                                                <table className='table table-bordered responsive-table'>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th>Product</th>
                                                                            <td className='fw-bold text-danger'>{formData.productCode}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Category</th>
                                                                            <td>{formData.categoryName}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Manufacturer</th>
                                                                            <td>{formData.manufacturerName}</td>
                                                                        </tr>
                                                                        {formData.otherManufacturer &&
                                                                            <tr>
                                                                                <th>Other Manufacturer</th>
                                                                                <td>{formData.otherManufacturer}</td>
                                                                            </tr>
                                                                        }
                                                                        {formData.serialNo &&
                                                                            <tr>
                                                                                <th>Serial No</th>
                                                                                <td>{formData.serialNo}</td>
                                                                            </tr>
                                                                        }
                                                                        <tr>
                                                                            <th>Model No</th>
                                                                            <td>{formData.modelName}</td>
                                                                        </tr>
                                                                        {formData.otherModelNo &&
                                                                            <tr>
                                                                                <th>Other Model</th>
                                                                                <td>{formData.otherModelNo}</td>
                                                                            </tr>
                                                                        }
                                                                        {formData.imei &&
                                                                            <tr>
                                                                                <th>IMEI</th>
                                                                                <td>{formData.imei} {formData.imeiImage &&
                                                                                    <div className='col-sm-3 pt-4'>
                                                                                        <i className="fa fa-image me-2"
                                                                                            title='show Image'
                                                                                            onClick={() => { OpenImage(formData.imeiImage, formData.imeiExt) }}
                                                                                            style={{ cursor: 'pointer', color: '#5a8dee', fontSize: '14px' }}
                                                                                        />
                                                                                    </div>
                                                                                }</td>
                                                                            </tr>
                                                                        }
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className='card mb-2' style={{ borderTop: '2px solid #008000', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px' }}>
                                                    <div className='card-body p-2 py-0'>
                                                        <div className="invoice-header d-flex justify-content-between align-items-center py-2 px-1">
                                                            <h6 className="invoice-title my-0" style={{ borderBottom: '2px solid #008000', color: '#008000' }}>
                                                                Customer Details
                                                            </h6>
                                                            <span className="toggle-icon-container">
                                                                {ShowSelectionForm.customerForm ?
                                                                    <IoIosArrowUp className="toggle-icon toggle-icon-up"
                                                                        onClick={() => setShowSelectionForm((pre) => ({ ...pre, customerForm: false }))} /> :
                                                                    <IoIosArrowDown className="toggle-icon toggle-icon-down" onClick={() => setShowSelectionForm((pre) => ({ ...pre, customerForm: true }))} />}
                                                            </span>
                                                        </div>
                                                        {ShowSelectionForm.customerForm &&
                                                            <div className='customer_table'>
                                                                <table className='table table-bordered'>
                                                                    <tbody>
                                                                        <tr>
                                                                            <th>Title</th>
                                                                            <td>{formData.title}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>First Name</th>
                                                                            <td>{formData.firstName}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Last Name</th>
                                                                            <td>{formData.lastName}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Gender</th>
                                                                            <td>{formData.gender}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Tel. Number</th>
                                                                            <td>{formData.telephoneNumber}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Email Address</th>
                                                                            <td>{formData.emailAddress}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Mobile No.</th>
                                                                            <td>{formData.mobilePhoneNumber}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Billing Postcode</th>
                                                                            <td>{formData.billingPostcode}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Billing Town</th>
                                                                            <td>{formData.billingTown}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Billing State</th>
                                                                            <td>{formData.billingState}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Billing Address Line 1</th>
                                                                            <td>{formData.billingAddressLine1}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Billing Address Line 2</th>
                                                                            <td>{formData.billingAddressLine2}</td>
                                                                        </tr>
                                                                        <tr>
                                                                            <th>Billing Address Line 3</th>
                                                                            <td>{formData.billingAddressLine3}</td>
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-md-3 col-sm-12 ps-md-1 sale-selectionType d-flex flex-column'>
                                                <div className='card flex-grow-1' style={{ borderTop: '2px solid orange', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px' }}>
                                                    <div className='card-body p-2 pt-0'>
                                                        <div className="invoice-header d-flex justify-content-between align-items-center py-2 px-1">
                                                            <h6 className="invoice-title my-0" style={{ borderBottom: '2px solid orange', color: 'orange' }}>
                                                                Amount Details
                                                            </h6>
                                                            <span className="toggle-icon-container">
                                                                {ShowSelectionForm.amountForm ?
                                                                    <IoIosArrowUp className="toggle-icon toggle-icon-up" onClick={() => setShowSelectionForm((pre) => ({ ...pre, amountForm: false }))} /> :
                                                                    <IoIosArrowDown className="toggle-icon toggle-icon-down" onClick={() => setShowSelectionForm((pre) => ({ ...pre, amountForm: true }))} />}
                                                            </span>
                                                        </div>
                                                        {ShowSelectionForm.amountForm &&

                                                            <div className='amount-details-container'>
                                                                <div className='detail-item'>
                                                                    <h6 className='detail-label fw-bold'>Membership Name</h6>
                                                                    <h6 className='detail-value'>{formData.assestProductName}</h6>
                                                                </div>
                                                                <div className='detail-item'>
                                                                    <h6 className='detail-label fw-bold'>Subscription Amount</h6>
                                                                    <span className='detail-amount'>
                                                                        ₹ {isNaN(parseInt(formData.cost, 10)) ? 0 : parseInt(formData.cost, 10)}
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>

                                                <div className=" mt-2">
                                                    <div className="card p-2 " style={{ borderTop: '2px solid orange', boxShadow: 'rgb(254 170 170 / 28%) 2px 2px 9px' }}>
                                                        <h6
                                                            className='mb-1 pb-1'
                                                            style={{ borderBottom: '1px solid orange', color: 'green' }}
                                                        >
                                                            Process Type
                                                        </h6>
                                                        <div className="Payment_section">
                                                            <div className="terms-condition">
                                                                <input
                                                                    type="checkbox"
                                                                    id="termsCheckbox"
                                                                    checked={isChecked}
                                                                    onChange={() => setIsChecked(!isChecked)}
                                                                />&nbsp;
                                                                <label htmlFor="termsCheckbox">
                                                                    I agree to the <a
                                                                        href={formData.pdfurl}
                                                                        target="_blank"
                                                                        rel='noreferrer'
                                                                    ><u>Terms and Conditions</u></a>.
                                                                </label>
                                                            </div>
                                                            <button type="submit"
                                                                onClick={handlePayment}
                                                                className="btn btn-rounded btn-success mb-0">
                                                                <span className=" text-white me-2">
                                                                    <i className="fa fa-credit-card" />
                                                                </span>{"Make Payment"}</button>
                                                            <div className='row w-100'>
                                                                <button type="button" name={'Cancel'}
                                                                    ref={ref => (inputrefs ? inputrefs.current['Cancel'] = ref : null)}
                                                                    onClick={HandleProcess}
                                                                    className="btn btn-rounded btn-danger me-2">
                                                                    <span className=" text-white me-2">
                                                                        <i className="fa fa-cancel" />
                                                                    </span>{"Cancel"}</button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                        : PaymentProcessType === 'PAYMENT' ?
                            <div className='card-header'>
                                <div className='container-fluid px-0'>
                                    <div className='row'>
                                        <div className='text-center'>
                                            <img src="./images/fail.png" style={{
                                                width: "140px",
                                                height: "120px",
                                            }} alt="Failure Icon" />
                                        </div>
                                        <h3 className='text-center px-5 pt-5 fw-bold text-danger'>{PaymentResponse?.status}</h3>
                                        <h5 className='text-center pb-2 px-5'>{PaymentResponse?.errorDesc}</h5>
                                        <h6 className='text-center px-5'>It seems there was a problem with your payment. Kindly try again.</h6>
                                        <div className='card-body pb-1 pt-2 d-flex algin-items-center justify-content-center'>
                                            <button type="button" name={'Prev'}
                                                onClick={() => handleRetryPayment()}
                                                className="btn btn-rounded btn-warning ms-2 p-1">
                                                <span className="text-white ">
                                                    <i className="fa-solid fa fa-refresh" />   Retry Payment
                                                </span>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            : (PaymentProcessType === 'FINAL' && !QueryCancelStatus) ?
                                <FinalView handleClear={handleClear} type={'Customer'} message={message} />
                                :
                                QueryCancelStatus && <ThankYou message={message} conformationType={conformationType} />
                    }
                    <Dialog
                        open={openPaymentModal}
                        onClose={() => setOpenPaymentModal(false)}
                        aria-labelledby="alert-dialog-title"
                        aria-describedby="alert-dialog-description"
                        sx={{
                            "& .MuiDialog-container": {
                                "& .MuiPaper-root": {
                                    width: "100%",
                                    maxWidth: "600px",
                                }
                            },
                            "& .css-hz1bth-MuiDialog-container": {
                                alignItems: 'start'
                            }
                        }}
                    >
                        <DialogTitle id="alert-dialog-title" className='py-1 px-2 border-bottom d-flex justify-content-between'>
                            <div style={{ fontWeight: 700 }}>{ProcessType ? 'Query' : 'Cancel Reason'}</div>
                            <div style={{ fontWeight: 500, cursor: 'pointer' }} title='close'><i className='fa-solid fa-xmark'
                                onClick={() => setOpenPaymentModal(false)}
                            /></div>
                        </DialogTitle>
                        <DialogContent className='main-card px-0 mx-0 my-0 py-1' style={{ boxShadow: 'none' }}>
                            <div className='row px-0 mx-1 pb-1 border-bottom'>
                                <div style={{
                                    border: '1px solid #4CAF50',
                                    backgroundColor: '#f0f8f5',
                                    borderRadius: '5px',
                                    padding: '10px',
                                }}>
                                    <div className="col-sm-12">
                                        <label style={{ 'whiteSpace': 'nowrap', fontSize: '14px' }} className="form-label" >Message <span className='required'>*</span></label>
                                        <textarea
                                            id="txtMessage"
                                            ref={ref => (inputrefs.current["txtMessage"] = ref)}
                                            className="col-lg-6 col-md-6 col-sm-12 form-control"
                                            placeholder="Message..."
                                            rows='5'
                                            value={customerData.message}
                                            onChange={(e) => setCustomerData({ ...customerData, message: e.target.value })}
                                        />
                                    </div>

                                </div>
                            </div>
                        </DialogContent>
                        <DialogActions className='main-card py-0 pt-1 my-0 px-1' style={{ boxShadow: 'none' }}>
                            <button type="button"
                                onClick={() => handleProcessSubmit()}
                                className="btn btn-rounded ms-1 text-light btn-success" >
                                <span className=" text-white me-2">
                                    <i className="fa">&#xf0c7;</i>
                                </span>Submit</button>
                        </DialogActions>
                    </Dialog>
                </div>
            </main>
            {SubLoading && <BlurLoader />}
        </>
    )
}
export default CustomerPayment;